export const mapToShortcut = (value: string): Set<string> => {
  return new Set(value.split(' + ').map(v => v.trim()));
};

export const mapShortcut = (shortcut: Set<string>): string => {
  return Array.from(shortcut).join(' + ');
};
